var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneOutbound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21359_10199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3019 12.0964L39.2656 2.09645L29.2656 2.13281",
    stroke: "#034D83",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6401 13.8072L39.2642 2.0982",
    stroke: "#034D83",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6941 28.6367L37.7123 33.6367C37.7159 34.1009 37.6224 34.5607 37.438 34.9866C37.2536 35.4126 36.9823 35.7954 36.6414 36.1104C36.3005 36.4254 35.8976 36.6658 35.4584 36.8161C35.0192 36.9664 34.5535 37.0233 34.0911 36.9832C28.9605 36.4446 24.0278 34.7101 19.6893 31.9189C15.653 29.3747 12.2265 25.973 9.65295 21.9553C6.82046 17.6176 5.04958 12.6737 4.48377 7.52405C4.44045 7.06331 4.49353 6.59861 4.63965 6.15951C4.78576 5.72042 5.0217 5.31656 5.33245 4.97365C5.64319 4.63073 6.02194 4.35628 6.44456 4.16776C6.86719 3.97925 7.32444 3.88079 7.7872 3.87868L12.7872 3.86049C13.596 3.84959 14.3812 4.13316 14.9964 4.65835C15.6116 5.18354 16.0148 5.91451 16.1309 6.71502C16.3478 8.31435 16.7449 9.88402 17.3146 11.3941C17.541 11.9898 17.5919 12.6379 17.4612 13.2617C17.3306 13.8854 17.0238 14.4587 16.5774 14.9134L14.4684 17.0378C16.8562 21.2017 20.3236 24.644 24.5047 27.0014L26.6137 24.877C27.0652 24.4273 27.6362 24.1164 28.259 23.9812C28.8818 23.846 29.5303 23.8922 30.1276 24.1142C31.6418 24.673 33.2143 25.0586 34.8152 25.2639C35.6252 25.3751 36.366 25.7802 36.8969 26.4021C37.4277 27.024 37.7114 27.8193 37.6941 28.6367Z",
    stroke: "#034D83",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21359_10199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.925781 0.570312) rotate(-0.208364)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOutbound);
export default __webpack_public_path__ + "static/media/phone-outbound.252e3b9605a8fa81db78a9f12a50c6d9.svg";
export { ForwardRef as ReactComponent };